import { RoundButton } from '@cian/ui-kit';
import { IconClose16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import * as styles from './RoundCloseButton.css';

interface IRoundCloseButtonProps {
  onClick(): void;
  testId?: string;
}

export const RoundCloseButton = ({ onClick, testId }: IRoundCloseButtonProps) => (
  <div className={styles['button']}>
    <RoundButton
      theme="fill_dark"
      size="M"
      onClick={onClick}
      title="Закрыть"
      icon={<IconClose16 color="brand-white" />}
      data-testid={testId}
    />
  </div>
);
